export const trackTourEvent = (projectId, eventType, formData = null) => {
  const body = { project_id: projectId, event_type: eventType }
  if (formData) body.form_data = formData

  return fetch('/tour_events', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  })
}

export const fetchTourAnalytics = (startDate, endDate) => {
  const params = new URLSearchParams()
  if (startDate) params.append('start_date', startDate)
  if (endDate) params.append('end_date', endDate)

  return fetch(`/tour_events?${params.toString()}`, {
    headers: { 'Content-Type': 'application/json' },
  }).then(res => res.json())
}
